import React from 'react';
import { useModal } from '../hooks/useModal';
import IntroNav from '../components/intro/IntroNav';
import HeroSection from '../components/intro/HeroSection';
import FeatureSection from '../components/intro/FeatureSection';
import ProfitSection from '../components/intro/ProfitSection';
import PartnersSection from '../components/intro/PartnersSection';
import CTASection from '../components/intro/CTASection';
import IntroFooter from '../components/intro/IntroFooter';
import ConsultModal from '../components/intro/ConsultModal';

function IntroPage() {
  const consultModal = useModal();

  // 샘플 쇼핑몰 URL 생성 (로컬/배포 환경 구분)
  const getSampleShopUrl = () => {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;
    const port = window.location.port ? `:${window.location.port}` : '';

    // SellerContext.js의 detectSubdomain 로직과 맞춤
    const devDomains = ['localhost', '127.0.0.1', 'dev-linkflower.ezylab.co.kr'];

    if (devDomains.includes(hostname)) {
      return `${protocol}//${hostname}${port}/?subdomain=admin-linkflower`;
    }

    // 배포 환경: 서브도메인 방식 사용 (예: admin-linkflower.f26.kr)
    // 루트 도메인은 마지막 두 라벨로 계산한다. hostname 전체를 쓰면 서브도메인 위에서
    // (예: www.f26.kr, 알 수 없는 서브도메인) admin-linkflower.xxx.f26.kr 처럼
    // 이중 서브도메인이 만들어져 DNS 와일드카드(*.f26.kr) 밖이라 접속이 깨진다.
    const parts = hostname.split('.');
    const rootDomain = parts.length >= 3 ? parts.slice(-2).join('.') : hostname;
    return `${protocol}//admin-linkflower.${rootDomain}`;
  };

  // 파비콘은 SellerContext에서 관리 (서브몰이 아닐 때는 기본 favicon.ico 유지)

  return (
    <div className="bg-background-light dark:bg-background-dark text-[#0e1b12] dark:text-gray-100 font-display transition-colors duration-300">
      <style>{`
        .material-symbols-outlined {
          font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes scaleIn {
          from { transform: scale(0.9); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
      `}</style>

      <IntroNav onConsultClick={() => consultModal.open()} />
      <HeroSection onConsultClick={() => consultModal.open()} sampleShopUrl={getSampleShopUrl()} />
      <FeatureSection />
      <ProfitSection />
      <PartnersSection />
      <CTASection onConsultClick={() => consultModal.open()} />
      <IntroFooter />
      <ConsultModal isOpen={consultModal.isOpen} onClose={() => consultModal.close()} />
    </div>
  );
}

export default IntroPage;
